import { render, staticRenderFns } from "./markManage.vue?vue&type=template&id=46b4762a&scoped=true&"
import script from "./markManage.vue?vue&type=script&lang=js&"
export * from "./markManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4762a",
  null
  
)

export default component.exports